import { render, staticRenderFns } from "./ranking-and-placement-grid.vue?vue&type=template&id=1ae698da&scoped=true"
import script from "./ranking-and-placement-grid.vue?vue&type=script&lang=js"
export * from "./ranking-and-placement-grid.vue?vue&type=script&lang=js"
import style0 from "./ranking-and-placement-grid.vue?vue&type=style&index=0&id=1ae698da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae698da",
  null
  
)

export default component.exports